module.exports = __webpack_public_path__ + "static/so-axe-a7ec2766ef7a34d1a99ee953585da20b.png";